<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
    >
        <rkm-row>
            <rkm-col class="auto">
                <rkm-form-select
                    :options="form.unidades"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :disabled="!model.unidadeId"
                    :options="form.competencias"
                    label="Competência"
                    show-default-option
                    text-field="valor"
                    v-model="model.competenciaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :disabled="!model.competenciaId"
                    :options="form.instrumentosRegistro"
                    label="Instrumento de registro"
                    show-default-option
                    text-field="nome"
                    v-model="model.registroCodigo"
                    value-field="codigo"
                />
            </rkm-col>

            <rkm-col class="flex-grow-0 text-nowrap">
                <rkm-button
                    :disabled="!model.registroCodigo || busy"
                    :label="false"
                    @click="handleBuscar"
                    color="primary"
                >
                    Buscar
                </rkm-button>

                <rkm-button
                    :disabled="!model.unidadeId || busy"
                    :label="false"
                    @click="handleLimpar"
                >
                    Limpar
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    created() {
        this.repositories.relatorioInconsistencia = this.getConectaSusRepository('bpa.relatorioInconsistencia')
    },
    data: () => ({
        busy: false,
        form: null,
        model: null,
        repositories: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioInconsistencia.list()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleBuscar() {
            this.busy = true
            this.$emit('busy', this.busy)
            this.$emit('model', this.model)

            const request = {
                unidadeId: this.model.unidadeId,
                competenciaId: this.model.competenciaId,
                registroCodigo: this.model.registroCodigo,
            }

            this.repositories.relatorioInconsistencia.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.$emit('items', response.data)
                })
                .catch(this.handleError)
                .finally(() => {
                    this.busy = false
                    this.$emit('busy', this.busy)
                })
        },
        handleLimpar() {
            this.model.unidadeId = null
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    watch: {
        'model.unidadeId'() {
            this.model.competenciaId = null
        },
        'model.competenciaId'() {
            this.model.registroCodigo = null
        },
        'model.registroCodigo'(value) {
            this.$emit('registro-codigo', value)
            this.$emit('items', [])
        },
    },
}
</script>